<template>
  <SysDirCommon :dir-name="'题库目录'" :dir-def-id="'inner_train'" :query-id="'iht_question'" ></SysDirCommon>
</template>

<script>

import SysDirCommon from "@/views/applications/sys/SysDirCommon.vue";

export default {
  name: "QuestionManage",
  components: {SysDirCommon},
  data() {
    return {}
  },
  created() {},
  methods: {},
}
</script>

<style lang="less" scoped>
@import 'src/global';

</style>

